import React from 'react';
import { Route } from "react-router-dom";
import AppLogout from '../../common/isLogout';
import { PrivateRoute } from '../../common/PrivateRoutes';
import QueryThreeWheelers from '../../Pages/QueryThreeWheelers';
import ViewQueryThreeWheelers from '../../Pages/ViewQueryThreeWheelers';
import DashboardLayout from '../../Layouts/DashboardLayouts';

const SupportRoutes = () => (
  <>
    {/* Suuport Query ThreeWheeler */}
    <Route element={<AppLogout><PrivateRoute><DashboardLayout /></PrivateRoute></AppLogout>}>
      <Route exact path="/3w/support/query" element={<AppLogout><PrivateRoute><QueryThreeWheelers /></PrivateRoute></AppLogout>} />
      <Route exact path="/3w/support/viewquery/:id" element={<AppLogout><PrivateRoute><ViewQueryThreeWheelers /></PrivateRoute></AppLogout>} />
    </Route>
  </>
);

export default SupportRoutes;